import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/Store";

const initialState = {
  loading: false,
  isUser: false,
  error: null as string | null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setIsUserTerminated: (state, action) => {
      state.isUser = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setLoading, setError, clearError, setIsUserTerminated } =
  uiSlice.actions;
export default uiSlice.reducer;

export const selectIsUserTerminated = (state: RootState) => state.ui.isUser;
